import { render, staticRenderFns } from "./SurgicalCase.vue?vue&type=template&id=55813b9b&scoped=true&"
import script from "./SurgicalCase.vue?vue&type=script&lang=js&"
export * from "./SurgicalCase.vue?vue&type=script&lang=js&"
import style0 from "./SurgicalCase.vue?vue&type=style&index=0&id=55813b9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55813b9b",
  null
  
)

export default component.exports